module.exports = __webpack_public_path__ + "static/img/12.cbf0f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/12.png
// module id = An77
// module chunks = 0